import React from 'react'
// @ts-ignore
import Linkify from 'react-linkify'
import Link from '../components/Link'

export const linkDecorator = (inputText: string) => {
  return <Linkify componentDecorator={(decoratedHref: string, decoratedText: string, key: string) => (
    <Link target={'_blank'} href={decoratedHref} key={key}>{decoratedText}</Link>)}>{inputText}</Linkify>
}
